import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordFaqIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.38813 36.6631C6.32456 36.3781 3.74978 34.1372 3.32555 31.0898C2.84011 27.6027 2.57031 24.0177 2.57031 20.3275C2.57031 16.5069 2.84021 12.7475 3.35994 9.14823C3.771 6.30159 6.09454 4.1529 8.955 3.85247C13.7873 3.34492 18.8359 3.07129 23.9989 3.07129C29.1458 3.07129 34.1053 3.36139 38.942 3.86149C41.8511 4.16229 44.2137 6.35562 44.6269 9.25098C45.1364 12.8224 45.4275 16.5399 45.4275 20.3275C45.4275 24.085 45.1093 27.7381 44.6084 31.285C44.1918 34.2357 41.7915 36.4875 38.8268 36.7889C34.0369 37.2754 29.0988 37.5836 23.9989 37.5836C23.8768 37.5836 23.7548 37.5833 23.6328 37.5829C20.0367 41.7195 17.2795 43.764 12.4604 45.9284V36.9476C11.6791 36.877 10.9022 36.8043 10.1301 36.7323C9.88226 36.7093 9.63495 36.686 9.38813 36.6631Z"
        fill="white"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0022 21.8538C24.0022 20.7011 24.9397 19.9941 26.5936 18.889C28.1278 17.8639 28.937 16.5342 28.577 14.7246C28.2171 12.915 26.7218 11.4197 24.9122 11.0598C22.0716 10.4947 19.3379 12.7382 19.3379 15.6345M23.9999 29.8351V28.978"
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordFaqIcon;
